import { UserState } from './types';

export const getUser = (state): UserState => state.user;
export const getIdentityId = (state) => getUser(state)?.user?.identityId;
export const getUserTimeZone = (state): string => state.user && state.user.user && state.user.user.timeZone;
export const customerIdSelector = (state): UserState['currentCompany'] => state.user.currentCompany;

/** Do not use directly. Use access rights hook */
export const isPlatformAllowedSelector = (state) => {
    const isPlatformAllowed = (features: string[], strict = true): boolean => {
        const fn = strict ? 'every' : 'some';

        return features[fn]((feature) => state.user.accessibleFeatures.includes(feature));
    };

    return { isPlatformAllowed, dep: state.user.accessibleFeatures };
};

export const isBynderScopeAllowedSelector = (state) => {
    return (scopes: string[]): boolean => scopes.some((scope) => state.user.bynderScopes.includes(scope));
};

/** Do not use directly. Use access rights hook */
export const isAccountRoleAssignedSelector = (state) => {
    return (role: string): boolean => {
        if (state?.user?.roles) {
            return state.user.roles.includes(role);
        }

        return false;
    };
};

export const getFonts = (state: { user: UserState }) => getUser(state).fonts;
export const getElementsFonts = (state: { user: UserState }) => getUser(state).elementsFonts;

export const getSplitFeatures = (state: { user: UserState }) => state.user.splitFeatures;
